"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRtcEngineDispatch = exports.IDirectCdnStreamingEventHandler = exports.IMetadataObserver = exports.IVideoDeviceManagerDispatch = exports.IRtcEngineEventHandler = void 0;
const native_rtc_1 = require("@iris/native-rtc");
const iris_web_core_1 = require("iris-web-core");
const CallApiBufferExtensions_1 = require("../extensions/CallApiBufferExtensions");
const EventhandlerBufferExtensions_1 = require("../extensions/EventhandlerBufferExtensions");
const IAgoraRtcEngineImpl_1 = require("../impl/IAgoraRtcEngineImpl");
const IVideoDeviceManagerImpl_1 = require("../impl/IVideoDeviceManagerImpl");
const AgoraConsole_1 = require("../util/AgoraConsole");
class IRtcEngineEventHandler {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onJoinChannelSuccess_ee6b011(channel, uid, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onJoinChannelSuccess_ee6b011 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRejoinChannelSuccess_ee6b011(channel, uid, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRejoinChannelSuccess_ee6b011 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onProxyConnected_9f89fd0(channel, uid, proxyType, localProxyIp, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onProxyConnected_9f89fd0 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onError_d26c0fd(err, msg) {
        let _obj = {
            err,
            msg,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onError_d26c0fd', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onAudioQuality_40aeca1(uid, quality, delay, lost) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioQuality_40aeca1 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLastmileProbeResult_42b5843(result) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLastmileProbeResult_42b5843 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioVolumeIndication_e9637c8(speakers, speakerNumber, totalVolume) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioVolumeIndication_e9637c8 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLeaveChannel_40ef426(stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLeaveChannel_40ef426 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRtcStats_40ef426(stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRtcStats_40ef426 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioDeviceStateChanged_976d8c3(deviceId, deviceType, deviceState) {
        let _obj = {
            deviceId,
            deviceType,
            deviceState,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onAudioDeviceStateChanged_976d8c3', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onAudioMixingPositionChanged_f631116(position) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioMixingPositionChanged_f631116 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioMixingFinished() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioMixingFinished not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioEffectFinished_46f8ab7(soundId) {
        let _obj = {
            soundId,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onAudioEffectFinished_46f8ab7', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onVideoDeviceStateChanged_976d8c3(deviceId, deviceType, deviceState) {
        let _obj = {
            deviceId,
            deviceType,
            deviceState,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onVideoDeviceStateChanged_976d8c3', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onNetworkQuality_68a324c(uid, txQuality, rxQuality) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onNetworkQuality_68a324c not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onIntraRequestReceived() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onIntraRequestReceived not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUplinkNetworkInfoUpdated_cbb1856(info) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUplinkNetworkInfoUpdated_cbb1856 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onDownlinkNetworkInfoUpdated_e9d5bd9(info) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onDownlinkNetworkInfoUpdated_e9d5bd9 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLastmileQuality_46f8ab7(quality) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLastmileQuality_46f8ab7 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onFirstLocalVideoFrame_ebdfd19(source, width, height, elapsed) {
        let _obj = {
            source,
            width,
            height,
            elapsed,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onFirstLocalVideoFrame_ebdfd19', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onFirstLocalVideoFramePublished_2ad83d8(source, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onFirstLocalVideoFramePublished_2ad83d8 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onFirstRemoteVideoDecoded_58b686c(uid, width, height, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onFirstRemoteVideoDecoded_58b686c not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onVideoSizeChanged_5f7d8e3(sourceType, uid, width, height, rotation) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onVideoSizeChanged_5f7d8e3 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLocalVideoStateChanged_a44228a(source, state, reason) {
        let _obj = {
            source,
            state,
            reason,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onLocalVideoStateChanged_a44228a', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onRemoteVideoStateChanged_815ab69(uid, state, reason, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRemoteVideoStateChanged_815ab69 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onFirstRemoteVideoFrame_58b686c(uid, width, height, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onFirstRemoteVideoFrame_58b686c not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUserJoined_88641bf(uid, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUserJoined_88641bf not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUserOffline_eb1e059(uid, reason) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUserOffline_eb1e059 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUserMuteAudio_dbdc15a(uid, muted) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUserMuteAudio_dbdc15a not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUserMuteVideo_dbdc15a(uid, muted) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUserMuteVideo_dbdc15a not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUserEnableVideo_dbdc15a(uid, enabled) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUserEnableVideo_dbdc15a not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUserStateChanged_c63723e(uid, state) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUserStateChanged_c63723e not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUserEnableLocalVideo_dbdc15a(uid, enabled) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUserEnableLocalVideo_dbdc15a not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRemoteAudioStats_4aba4cc(stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRemoteAudioStats_4aba4cc not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLocalAudioStats_8fcb8ec(stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLocalAudioStats_8fcb8ec not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLocalVideoStats_baa96c8(source, stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLocalVideoStats_baa96c8 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRemoteVideoStats_e271890(stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRemoteVideoStats_e271890 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onCameraReady() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onCameraReady not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onCameraFocusAreaChanged_41c5354(x, y, width, height) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onCameraFocusAreaChanged_41c5354 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onCameraExposureAreaChanged_41c5354(x, y, width, height) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onCameraExposureAreaChanged_41c5354 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onFacePositionChanged_197b4a7(imageWidth, imageHeight, vecRectangle, vecDistance, numFaces) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onFacePositionChanged_197b4a7 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onVideoStopped() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onVideoStopped not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioMixingStateChanged_fd2c0a6(state, reason) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioMixingStateChanged_fd2c0a6 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRhythmPlayerStateChanged_09360d2(state, reason) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRhythmPlayerStateChanged_09360d2 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onConnectionLost() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onConnectionLost not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onConnectionInterrupted() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onConnectionInterrupted not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onConnectionBanned() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onConnectionBanned not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onStreamMessage_6f90bce(uid, streamId, data, length, sentTs) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onStreamMessage_6f90bce not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onStreamMessageError_21e5c1a(uid, streamId, code, missed, cached) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onStreamMessageError_21e5c1a not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRequestToken() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRequestToken not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onTokenPrivilegeWillExpire_3a2037f(token) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onTokenPrivilegeWillExpire_3a2037f not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLicenseValidationFailure_4518fcc(error) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLicenseValidationFailure_4518fcc not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onFirstLocalAudioFramePublished_46f8ab7(elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onFirstLocalAudioFramePublished_46f8ab7 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onFirstRemoteAudioDecoded_88641bf(uid, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onFirstRemoteAudioDecoded_88641bf not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onFirstRemoteAudioFrame_88641bf(uid, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onFirstRemoteAudioFrame_88641bf not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLocalAudioStateChanged_f33d789(state, reason) {
        let _obj = {
            state,
            reason,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onLocalAudioStateChanged_f33d789', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onRemoteAudioStateChanged_f1532dd(uid, state, reason, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRemoteAudioStateChanged_f1532dd not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onActiveSpeaker_c8d091a(uid) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onActiveSpeaker_c8d091a not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onContentInspectResult_ba185c8(result) {
        let _obj = {
            result,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onContentInspectResult_ba185c8', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onSnapshotTaken_c495bf6(uid, filePath, width, height, errCode) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onSnapshotTaken_c495bf6 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onClientRoleChanged_938fb25(oldRole, newRole, newRoleOptions) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onClientRoleChanged_938fb25 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onClientRoleChangeFailed_386f862(reason, currentRole) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onClientRoleChangeFailed_386f862 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioDeviceVolumeChanged_55ab726(deviceType, volume, muted) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioDeviceVolumeChanged_55ab726 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRtmpStreamingStateChanged_1f07503(url, state, reason) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRtmpStreamingStateChanged_1f07503 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRtmpStreamingEvent_2e48ef5(url, eventCode) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRtmpStreamingEvent_2e48ef5 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onTranscodingUpdated() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onTranscodingUpdated not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioRoutingChanged_46f8ab7(routing) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioRoutingChanged_46f8ab7 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onChannelMediaRelayStateChanged_4e92b3c(state, code) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onChannelMediaRelayStateChanged_4e92b3c not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLocalPublishFallbackToAudioOnly_5039d15(isFallbackOrRecover) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLocalPublishFallbackToAudioOnly_5039d15 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRemoteSubscribeFallbackToAudioOnly_dbdc15a(uid, isFallbackOrRecover) {
        let _obj = {
            uid,
            isFallbackOrRecover,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onRemoteSubscribeFallbackToAudioOnly_dbdc15a', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onRemoteAudioTransportStats_bd01ada(uid, delay, lost, rxKBitRate) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRemoteAudioTransportStats_bd01ada not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRemoteVideoTransportStats_bd01ada(uid, delay, lost, rxKBitRate) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRemoteVideoTransportStats_bd01ada not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onConnectionStateChanged_ec7c9c0(state, reason) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onConnectionStateChanged_ec7c9c0 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onWlAccMessage_333465b(reason, action, wlAccMsg) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onWlAccMessage_333465b not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onWlAccStats_94ee38e(currentStats, averageStats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onWlAccStats_94ee38e not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onNetworkTypeChanged_e85a70d(type) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onNetworkTypeChanged_e85a70d not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onEncryptionError_a0d1b74(errorType) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onEncryptionError_a0d1b74 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onPermissionError_f37c62b(permissionType) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onPermissionError_f37c62b not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLocalUserRegistered_1922dd1(uid, userAccount) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLocalUserRegistered_1922dd1 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUserInfoUpdated_2120245(uid, info) {
        let _obj = {
            uid,
            info,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onUserInfoUpdated_2120245', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onUserAccountUpdated_1922dd1(uid, userAccount) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUserAccountUpdated_1922dd1 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onVideoRenderingTracingResult_76e2449(uid, currentEvent, tracingInfo) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onVideoRenderingTracingResult_76e2449 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLocalVideoTranscoderError_83e3a9c(stream, error) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLocalVideoTranscoderError_83e3a9c not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUploadLogResult_eef29d2(requestId, success, reason) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUploadLogResult_eef29d2 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioSubscribeStateChanged_e0ec28e(channel, uid, oldState, newState, elapseSinceLastState) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioSubscribeStateChanged_e0ec28e not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onVideoSubscribeStateChanged_e0ec28e(channel, uid, oldState, newState, elapseSinceLastState) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onVideoSubscribeStateChanged_e0ec28e not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioPublishStateChanged_2c13a28(channel, oldState, newState, elapseSinceLastState) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioPublishStateChanged_2c13a28 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onVideoPublishStateChanged_5b45b6e(source, channel, oldState, newState, elapseSinceLastState) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onVideoPublishStateChanged_5b45b6e not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onTranscodedStreamLayoutInfo_3bfb91b(uid, width, height, layoutCount, layoutlist) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onTranscodedStreamLayoutInfo_3bfb91b not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioMetadataReceived_77edd82(uid, metadata, length) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioMetadataReceived_77edd82 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onExtensionEventWithContext_a5fb27a(context, key, value) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onExtensionEventWithContext_a5fb27a not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onExtensionStartedWithContext_67c38e3(context) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onExtensionStartedWithContext_67c38e3 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onExtensionStoppedWithContext_67c38e3(context) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onExtensionStoppedWithContext_67c38e3 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onExtensionErrorWithContext_a452f11(context, error, message) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onExtensionErrorWithContext_a452f11 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onSetRtmFlagResult_46f8ab7(code) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onSetRtmFlagResult_46f8ab7 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onJoinChannelSuccess_263e4cd(connection, elapsed) {
        let _obj = {
            connection,
            elapsed,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onJoinChannelSuccess_263e4cd', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onRejoinChannelSuccess_263e4cd(connection, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRejoinChannelSuccess_263e4cd not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioQuality_5c7294b(connection, remoteUid, quality, delay, lost) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioQuality_5c7294b not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioVolumeIndication_781482a(connection, speakers, speakerNumber, totalVolume) {
        let _obj = {
            connection,
            speakers,
            speakerNumber,
            totalVolume,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onAudioVolumeIndication_781482a', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onLeaveChannel_c8e730d(connection, stats) {
        let _obj = {
            connection,
            stats,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onLeaveChannel_c8e730d', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onRtcStats_c8e730d(connection, stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRtcStats_c8e730d not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onNetworkQuality_34d8b3c(connection, remoteUid, txQuality, rxQuality) {
        let _obj = {
            connection,
            remoteUid,
            txQuality,
            rxQuality,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onNetworkQuality_34d8b3c', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onIntraRequestReceived_c81e1a4(connection) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onIntraRequestReceived_c81e1a4 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onFirstLocalVideoFramePublished_263e4cd(connection, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onFirstLocalVideoFramePublished_263e4cd not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onFirstRemoteVideoDecoded_a68170a(connection, remoteUid, width, height, elapsed) {
        let _obj = {
            connection,
            remoteUid,
            width,
            height,
            elapsed,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onFirstRemoteVideoDecoded_a68170a', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onVideoSizeChanged_99bf45c(connection, sourceType, uid, width, height, rotation) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onVideoSizeChanged_99bf45c not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRemoteVideoStateChanged_a14e9d1(connection, remoteUid, state, reason, elapsed) {
        let _obj = {
            connection,
            remoteUid,
            state,
            reason,
            elapsed,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onRemoteVideoStateChanged_a14e9d1', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onFirstRemoteVideoFrame_a68170a(connection, remoteUid, width, height, elapsed) {
        let _obj = {
            connection,
            remoteUid,
            width,
            height,
            elapsed,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onFirstRemoteVideoFrame_a68170a', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onUserJoined_c5499bd(connection, remoteUid, elapsed) {
        let _obj = {
            connection,
            remoteUid,
            elapsed,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onUserJoined_c5499bd', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onUserOffline_0a32aac(connection, remoteUid, reason) {
        let _obj = {
            connection,
            remoteUid,
            reason,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onUserOffline_0a32aac', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onUserMuteAudio_0aac2fe(connection, remoteUid, muted) {
        let _obj = {
            connection,
            remoteUid,
            muted,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onUserMuteAudio_0aac2fe', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onUserMuteVideo_0aac2fe(connection, remoteUid, muted) {
        let _obj = {
            connection,
            remoteUid,
            muted,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onUserMuteVideo_0aac2fe', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onUserEnableVideo_0aac2fe(connection, remoteUid, enabled) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUserEnableVideo_0aac2fe not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUserEnableLocalVideo_0aac2fe(connection, remoteUid, enabled) {
        let _obj = {
            connection,
            remoteUid,
            enabled,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onUserEnableLocalVideo_0aac2fe', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onUserStateChanged_65f95a7(connection, remoteUid, state) {
        let _obj = {
            connection,
            remoteUid,
            state,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onUserStateChanged_65f95a7', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onLocalAudioStats_5657f05(connection, stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLocalAudioStats_5657f05 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRemoteAudioStats_ffbde06(connection, stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRemoteAudioStats_ffbde06 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLocalVideoStats_3ac0eb4(connection, stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLocalVideoStats_3ac0eb4 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRemoteVideoStats_2f43a70(connection, stats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRemoteVideoStats_2f43a70 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onConnectionLost_c81e1a4(connection) {
        let _obj = {
            connection,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onConnectionLost_c81e1a4', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onConnectionInterrupted_c81e1a4(connection) {
        let _obj = {
            connection,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onConnectionInterrupted_c81e1a4', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onConnectionBanned_c81e1a4(connection) {
        let _obj = {
            connection,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onConnectionBanned_c81e1a4', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onStreamMessage_99898cb(connection, remoteUid, streamId, data, length, sentTs) {
        let _obj = {
            connection,
            remoteUid,
            streamId,
            data,
            length,
            sentTs,
        };
        let bufferList = (0, EventhandlerBufferExtensions_1.eventHandlerBufferExtension)('RtcEngineEventHandler_onStreamMessage_99898cb', _obj);
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onStreamMessage_99898cb', _json, 0, '', bufferList, [], bufferList.length);
        this.notifyEvent(eventParam);
    }
    onStreamMessageError_fe302fc(connection, remoteUid, streamId, code, missed, cached) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onStreamMessageError_fe302fc not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRequestToken_c81e1a4(connection) {
        let _obj = {
            connection,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onRequestToken_c81e1a4', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onLicenseValidationFailure_5dfd95e(connection, reason) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onLicenseValidationFailure_5dfd95e not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onTokenPrivilegeWillExpire_8225ea3(connection, token) {
        let _obj = {
            connection,
            token,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onTokenPrivilegeWillExpire_8225ea3', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onFirstLocalAudioFramePublished_263e4cd(connection, elapsed) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onFirstLocalAudioFramePublished_263e4cd not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onFirstRemoteAudioFrame_c5499bd(connection, userId, elapsed) {
        let _obj = {
            connection,
            userId,
            elapsed,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onFirstRemoteAudioFrame_c5499bd', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onFirstRemoteAudioDecoded_c5499bd(connection, uid, elapsed) {
        let _obj = {
            connection,
            uid,
            elapsed,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onFirstRemoteAudioDecoded_c5499bd', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onLocalAudioStateChanged_13b6c02(connection, state, reason) {
        let _obj = {
            connection,
            state,
            reason,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onLocalAudioStateChanged_13b6c02', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onRemoteAudioStateChanged_056772e(connection, remoteUid, state, reason, elapsed) {
        let _obj = {
            connection,
            remoteUid,
            state,
            reason,
            elapsed,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onRemoteAudioStateChanged_056772e', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onActiveSpeaker_dd67adc(connection, uid) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onActiveSpeaker_dd67adc not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onClientRoleChanged_2acaf10(connection, oldRole, newRole, newRoleOptions) {
        let _obj = {
            connection,
            oldRole,
            newRole,
            newRoleOptions,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onClientRoleChanged_2acaf10', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onClientRoleChangeFailed_5a3af5b(connection, reason, currentRole) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onClientRoleChangeFailed_5a3af5b not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRemoteAudioTransportStats_527a345(connection, remoteUid, delay, lost, rxKBitRate) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRemoteAudioTransportStats_527a345 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRemoteVideoTransportStats_527a345(connection, remoteUid, delay, lost, rxKBitRate) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onRemoteVideoTransportStats_527a345 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onConnectionStateChanged_4075a9c(connection, state, reason) {
        let _obj = {
            connection,
            state,
            reason,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onConnectionStateChanged_4075a9c', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onWlAccMessage_2b9068e(connection, reason, action, wlAccMsg) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onWlAccMessage_2b9068e not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onWlAccStats_b162607(connection, currentStats, averageStats) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onWlAccStats_b162607 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onNetworkTypeChanged_388fd6f(connection, type) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onNetworkTypeChanged_388fd6f not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onEncryptionError_e7a65fe(connection, errorType) {
        let _obj = {
            connection,
            errorType,
        };
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('RtcEngineEventHandler_onEncryptionError_e7a65fe', _json, 0, '', [], [], 0);
        this.notifyEvent(eventParam);
    }
    onUploadLogResult_3115804(connection, requestId, success, reason) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUploadLogResult_3115804 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onUserAccountUpdated_de1c015(connection, remoteUid, remoteUserAccount) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onUserAccountUpdated_de1c015 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onSnapshotTaken_5a6a693(connection, uid, filePath, width, height, errCode) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onSnapshotTaken_5a6a693 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onVideoRenderingTracingResult_813c0f4(connection, uid, currentEvent, tracingInfo) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onVideoRenderingTracingResult_813c0f4 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onSetRtmFlagResult_263e4cd(connection, code) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onSetRtmFlagResult_263e4cd not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onTranscodedStreamLayoutInfo_48f6419(connection, uid, width, height, layoutCount, layoutlist) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onTranscodedStreamLayoutInfo_48f6419 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onAudioMetadataReceived_0d4eb96(connection, uid, metadata, length) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEventHandler_onAudioMetadataReceived_0d4eb96 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IRtcEngineEventHandler = IRtcEngineEventHandler;
class IVideoDeviceManagerDispatch {
    constructor(engine) {
        this._impl = new IVideoDeviceManagerImpl_1.IVideoDeviceManagerImpl(engine);
        this._engine = engine;
    }
    // @ts-ignore
    enumerateVideoDevices() {
        return this._impl.enumerateVideoDevices();
    }
    // @ts-ignore
    setDevice_4ad5f6e(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let deviceIdUTF8 = obj.deviceIdUTF8;
        if (deviceIdUTF8 === undefined) {
            AgoraConsole_1.AgoraConsole.error('deviceIdUTF8 is undefined');
            throw 'deviceIdUTF8 is undefined';
        }
        return this._impl.setDevice_4ad5f6e(deviceIdUTF8);
    }
    // @ts-ignore
    getDevice_73b9872() {
        return this._impl.getDevice_73b9872();
    }
    // @ts-ignore
    numberOfCapabilities_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('VideoDeviceManager_numberOfCapabilities_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getCapability_ddeefdd(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('VideoDeviceManager_getCapability_ddeefdd not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startDeviceTest_a55f55f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('VideoDeviceManager_startDeviceTest_a55f55f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopDeviceTest() {
        AgoraConsole_1.AgoraConsole.warn('VideoDeviceManager_stopDeviceTest not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    release() {
        return this._impl.release();
    }
}
exports.IVideoDeviceManagerDispatch = IVideoDeviceManagerDispatch;
class IMetadataObserver {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    getMaxMetadataSize() {
        AgoraConsole_1.AgoraConsole.warn('MetadataObserver_getMaxMetadataSize not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onReadyToSendMetadata_cbf4b59(metadata, source_type) {
        AgoraConsole_1.AgoraConsole.warn('MetadataObserver_onReadyToSendMetadata_cbf4b59 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onMetadataReceived_cb7661d(metadata) {
        AgoraConsole_1.AgoraConsole.warn('MetadataObserver_onMetadataReceived_cb7661d not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IMetadataObserver = IMetadataObserver;
class IDirectCdnStreamingEventHandler {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onDirectCdnStreamingStateChanged_40f1fa3(state, reason, message) {
        AgoraConsole_1.AgoraConsole.warn('DirectCdnStreamingEventHandler_onDirectCdnStreamingStateChanged_40f1fa3 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onDirectCdnStreamingStats_d50595f(stats) {
        AgoraConsole_1.AgoraConsole.warn('DirectCdnStreamingEventHandler_onDirectCdnStreamingStats_d50595f not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IDirectCdnStreamingEventHandler = IDirectCdnStreamingEventHandler;
class IRtcEngineDispatch {
    constructor(engine) {
        this._impl = new IAgoraRtcEngineImpl_1.IRtcEngineImpl(engine);
        this._engine = engine;
    }
    // @ts-ignore
    initialize_0320339(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let context = obj.context;
        if (context === undefined) {
            AgoraConsole_1.AgoraConsole.error('context is undefined');
            throw 'context is undefined';
        }
        return this._impl.initialize_0320339(context);
    }
    // @ts-ignore
    queryInterface_257d192(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_queryInterface_257d192 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getVersion_915cb25() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getVersion_915cb25 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getErrorDescription_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getErrorDescription_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    queryCodecCapability_ddf4f31(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_queryCodecCapability_ddf4f31 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    queryDeviceScore() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_queryDeviceScore not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    preloadChannel_a0779eb(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_preloadChannel_a0779eb not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    preloadChannelWithUserAccount_0e4f59e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_preloadChannelWithUserAccount_0e4f59e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updatePreloadChannelToken_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_updatePreloadChannelToken_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    joinChannel_f097389(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let token = obj.token;
        if (token === undefined) {
            AgoraConsole_1.AgoraConsole.error('token is undefined');
            throw 'token is undefined';
        }
        let channelId = obj.channelId;
        if (channelId === undefined) {
            AgoraConsole_1.AgoraConsole.error('channelId is undefined');
            throw 'channelId is undefined';
        }
        let info = obj.info;
        if (info === undefined) {
            AgoraConsole_1.AgoraConsole.error('info is undefined');
            throw 'info is undefined';
        }
        let uid = obj.uid;
        if (uid === undefined) {
            AgoraConsole_1.AgoraConsole.error('uid is undefined');
            throw 'uid is undefined';
        }
        return this._impl.joinChannel_f097389(token, channelId, info, uid);
    }
    // @ts-ignore
    joinChannel_cdbb747(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let token = obj.token;
        if (token === undefined) {
            AgoraConsole_1.AgoraConsole.error('token is undefined');
            throw 'token is undefined';
        }
        let channelId = obj.channelId;
        if (channelId === undefined) {
            AgoraConsole_1.AgoraConsole.error('channelId is undefined');
            throw 'channelId is undefined';
        }
        let uid = obj.uid;
        if (uid === undefined) {
            AgoraConsole_1.AgoraConsole.error('uid is undefined');
            throw 'uid is undefined';
        }
        let options = obj.options;
        if (options === undefined) {
            AgoraConsole_1.AgoraConsole.error('options is undefined');
            throw 'options is undefined';
        }
        return this._impl.joinChannel_cdbb747(token, channelId, uid, options);
    }
    // @ts-ignore
    updateChannelMediaOptions_7bfc1d7(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let options = obj.options;
        if (options === undefined) {
            AgoraConsole_1.AgoraConsole.error('options is undefined');
            throw 'options is undefined';
        }
        return this._impl.updateChannelMediaOptions_7bfc1d7(options);
    }
    // @ts-ignore
    leaveChannel() {
        return this._impl.leaveChannel();
    }
    // @ts-ignore
    leaveChannel_2c0e3aa(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let options = obj.options;
        if (options === undefined) {
            AgoraConsole_1.AgoraConsole.error('options is undefined');
            throw 'options is undefined';
        }
        return this._impl.leaveChannel_2c0e3aa(options);
    }
    // @ts-ignore
    renewToken_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_renewToken_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setChannelProfile_a78fa4f(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let profile = obj.profile;
        if (profile === undefined) {
            AgoraConsole_1.AgoraConsole.error('profile is undefined');
            throw 'profile is undefined';
        }
        return this._impl.setChannelProfile_a78fa4f(profile);
    }
    // @ts-ignore
    setClientRole_3426fa6(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let role = obj.role;
        if (role === undefined) {
            AgoraConsole_1.AgoraConsole.error('role is undefined');
            throw 'role is undefined';
        }
        return this._impl.setClientRole_3426fa6(role);
    }
    // @ts-ignore
    setClientRole_b46cc48(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let role = obj.role;
        if (role === undefined) {
            AgoraConsole_1.AgoraConsole.error('role is undefined');
            throw 'role is undefined';
        }
        let options = obj.options;
        if (options === undefined) {
            AgoraConsole_1.AgoraConsole.error('options is undefined');
            throw 'options is undefined';
        }
        return this._impl.setClientRole_b46cc48(role, options);
    }
    // @ts-ignore
    startEchoTest_16140d7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startEchoTest_16140d7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopEchoTest() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopEchoTest not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableMultiCamera_bffe023(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableMultiCamera_bffe023 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableVideo() {
        return this._impl.enableVideo();
    }
    // @ts-ignore
    disableVideo() {
        return this._impl.disableVideo();
    }
    // @ts-ignore
    startPreview() {
        return this._impl.startPreview();
    }
    // @ts-ignore
    startPreview_4fd718e(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let sourceType = obj.sourceType;
        if (sourceType === undefined) {
            AgoraConsole_1.AgoraConsole.error('sourceType is undefined');
            throw 'sourceType is undefined';
        }
        return this._impl.startPreview_4fd718e(sourceType);
    }
    // @ts-ignore
    stopPreview() {
        return this._impl.stopPreview();
    }
    // @ts-ignore
    stopPreview_4fd718e(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let sourceType = obj.sourceType;
        if (sourceType === undefined) {
            AgoraConsole_1.AgoraConsole.error('sourceType is undefined');
            throw 'sourceType is undefined';
        }
        return this._impl.stopPreview_4fd718e(sourceType);
    }
    // @ts-ignore
    startLastmileProbeTest_c4de423(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startLastmileProbeTest_c4de423 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopLastmileProbeTest() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopLastmileProbeTest not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setVideoEncoderConfiguration_89677d8(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let config = obj.config;
        if (config === undefined) {
            AgoraConsole_1.AgoraConsole.error('config is undefined');
            throw 'config is undefined';
        }
        return this._impl.setVideoEncoderConfiguration_89677d8(config);
    }
    // @ts-ignore
    setBeautyEffectOptions_e7635d1(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setBeautyEffectOptions_e7635d1 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setFaceShapeBeautyOptions_a862ce7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setFaceShapeBeautyOptions_a862ce7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setFaceShapeAreaOptions_2e242a3(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setFaceShapeAreaOptions_2e242a3 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getFaceShapeBeautyOptions_8382895(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getFaceShapeBeautyOptions_8382895 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getFaceShapeAreaOptions_0783e2c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getFaceShapeAreaOptions_0783e2c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setFilterEffectOptions_53b4be3(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setFilterEffectOptions_53b4be3 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLowlightEnhanceOptions_4f9f013(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLowlightEnhanceOptions_4f9f013 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setVideoDenoiserOptions_4e9fccc(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setVideoDenoiserOptions_4e9fccc not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setColorEnhanceOptions_ecae2b3(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setColorEnhanceOptions_ecae2b3 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // GEN-153: dispatch → impl. Payload da Flutter SDK:
    //   { enabled: bool, backgroundSource: VirtualBackgroundSource,
    //     segproperty: SegmentationProperty, type: MEDIA_SOURCE_TYPE }
    // @ts-ignore
    enableVirtualBackground_6dd8ee4(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let enabled = obj.enabled;
        if (enabled === undefined) {
            AgoraConsole_1.AgoraConsole.error('enabled is undefined');
            throw 'enabled is undefined';
        }
        let backgroundSource = obj.backgroundSource;
        if (backgroundSource === undefined) {
            AgoraConsole_1.AgoraConsole.error('backgroundSource is undefined');
            throw 'backgroundSource is undefined';
        }
        let segproperty = obj.segproperty;
        if (segproperty === undefined) {
            AgoraConsole_1.AgoraConsole.error('segproperty is undefined');
            throw 'segproperty is undefined';
        }
        let type = obj.type;
        return this._impl.enableVirtualBackground_6dd8ee4(enabled, backgroundSource, segproperty, type);
    }
    // @ts-ignore
    setupRemoteVideo_acc9c38(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setupRemoteVideo_acc9c38 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setupLocalVideo_acc9c38(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let canvas = obj.canvas;
        if (canvas === undefined) {
            AgoraConsole_1.AgoraConsole.error('canvas is undefined');
            throw 'canvas is undefined';
        }
        return this._impl.setupLocalVideo_acc9c38(canvas);
    }
    // @ts-ignore
    setVideoScenario_c02cd1c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setVideoScenario_c02cd1c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setVideoQoEPreference_c4a3d9f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setVideoQoEPreference_c4a3d9f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableAudio() {
        return this._impl.enableAudio();
    }
    // @ts-ignore
    disableAudio() {
        return this._impl.disableAudio();
    }
    // @ts-ignore
    setAudioProfile_d944543(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let profile = obj.profile;
        if (profile === undefined) {
            AgoraConsole_1.AgoraConsole.error('profile is undefined');
            throw 'profile is undefined';
        }
        let scenario = obj.scenario;
        if (scenario === undefined) {
            AgoraConsole_1.AgoraConsole.error('scenario is undefined');
            throw 'scenario is undefined';
        }
        return this._impl.setAudioProfile_d944543(profile, scenario);
    }
    // @ts-ignore
    setAudioProfile_ac39c15(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let profile = obj.profile;
        if (profile === undefined) {
            AgoraConsole_1.AgoraConsole.error('profile is undefined');
            throw 'profile is undefined';
        }
        return this._impl.setAudioProfile_ac39c15(profile);
    }
    // @ts-ignore
    setAudioScenario_c36f5c1(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAudioScenario_c36f5c1 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableLocalAudio_5039d15(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let enabled = obj.enabled;
        if (enabled === undefined) {
            AgoraConsole_1.AgoraConsole.error('enabled is undefined');
            throw 'enabled is undefined';
        }
        return this._impl.enableLocalAudio_5039d15(enabled);
    }
    // @ts-ignore
    muteLocalAudioStream_5039d15(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        return this._impl.muteLocalAudioStream_5039d15(mute);
    }
    // @ts-ignore
    muteAllRemoteAudioStreams_5039d15(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        return this._impl.muteAllRemoteAudioStreams_5039d15(mute);
    }
    // @ts-ignore
    muteRemoteAudioStream_dbdc15a(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let uid = obj.uid;
        if (uid === undefined) {
            AgoraConsole_1.AgoraConsole.error('uid is undefined');
            throw 'uid is undefined';
        }
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        return this._impl.muteRemoteAudioStream_dbdc15a(uid, mute);
    }
    // @ts-ignore
    muteLocalVideoStream_5039d15(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        return this._impl.muteLocalVideoStream_5039d15(mute);
    }
    // @ts-ignore
    enableLocalVideo_5039d15(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let enabled = obj.enabled;
        if (enabled === undefined) {
            AgoraConsole_1.AgoraConsole.error('enabled is undefined');
            throw 'enabled is undefined';
        }
        return this._impl.enableLocalVideo_5039d15(enabled);
    }
    // @ts-ignore
    muteAllRemoteVideoStreams_5039d15(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        return this._impl.muteAllRemoteVideoStreams_5039d15(mute);
    }
    // @ts-ignore
    setRemoteDefaultVideoStreamType_5a94eb0(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setRemoteDefaultVideoStreamType_5a94eb0 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    muteRemoteVideoStream_dbdc15a(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let uid = obj.uid;
        if (uid === undefined) {
            AgoraConsole_1.AgoraConsole.error('uid is undefined');
            throw 'uid is undefined';
        }
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        return this._impl.muteRemoteVideoStream_dbdc15a(uid, mute);
    }
    // @ts-ignore
    setRemoteVideoStreamType_9e6406e(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let uid = obj.uid;
        if (uid === undefined) {
            AgoraConsole_1.AgoraConsole.error('uid is undefined');
            throw 'uid is undefined';
        }
        let streamType = obj.streamType;
        if (streamType === undefined) {
            AgoraConsole_1.AgoraConsole.error('streamType is undefined');
            throw 'streamType is undefined';
        }
        return this._impl.setRemoteVideoStreamType_9e6406e(uid, streamType);
    }
    // @ts-ignore
    setRemoteVideoSubscriptionOptions_0b6b258(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setRemoteVideoSubscriptionOptions_0b6b258 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSubscribeAudioBlocklist_2d31fd5(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setSubscribeAudioBlocklist_2d31fd5 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSubscribeAudioAllowlist_2d31fd5(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setSubscribeAudioAllowlist_2d31fd5 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSubscribeVideoBlocklist_2d31fd5(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setSubscribeVideoBlocklist_2d31fd5 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSubscribeVideoAllowlist_2d31fd5(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setSubscribeVideoAllowlist_2d31fd5 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableAudioVolumeIndication_39794a0(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let interval = obj.interval;
        if (interval === undefined) {
            AgoraConsole_1.AgoraConsole.error('interval is undefined');
            throw 'interval is undefined';
        }
        let smooth = obj.smooth;
        if (smooth === undefined) {
            AgoraConsole_1.AgoraConsole.error('smooth is undefined');
            throw 'smooth is undefined';
        }
        let reportVad = obj.reportVad;
        if (reportVad === undefined) {
            AgoraConsole_1.AgoraConsole.error('reportVad is undefined');
            throw 'reportVad is undefined';
        }
        return this._impl.enableAudioVolumeIndication_39794a0(interval, smooth, reportVad);
    }
    // @ts-ignore
    startAudioRecording_6161339(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startAudioRecording_6161339 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startAudioRecording_410d265(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startAudioRecording_410d265 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startAudioRecording_e32bb3b(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startAudioRecording_e32bb3b not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerAudioEncodedFrameObserver_ed4a177(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_registerAudioEncodedFrameObserver_ed4a177 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopAudioRecording() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopAudioRecording not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    createMediaPlayer() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_createMediaPlayer not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    destroyMediaPlayer_328a49b(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_destroyMediaPlayer_328a49b not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    createMediaRecorder_f779617(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_createMediaRecorder_f779617 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    destroyMediaRecorder_95cdef5(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_destroyMediaRecorder_95cdef5 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startAudioMixing_f3db86c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startAudioMixing_f3db86c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startAudioMixing_1ee1b1e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startAudioMixing_1ee1b1e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopAudioMixing() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopAudioMixing not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    pauseAudioMixing() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_pauseAudioMixing not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    resumeAudioMixing() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_resumeAudioMixing not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    selectAudioTrack_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_selectAudioTrack_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getAudioTrackCount() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getAudioTrackCount not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustAudioMixingVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_adjustAudioMixingVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustAudioMixingPublishVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_adjustAudioMixingPublishVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getAudioMixingPublishVolume() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getAudioMixingPublishVolume not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustAudioMixingPlayoutVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_adjustAudioMixingPlayoutVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getAudioMixingPlayoutVolume() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getAudioMixingPlayoutVolume not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getAudioMixingDuration() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getAudioMixingDuration not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getAudioMixingCurrentPosition() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getAudioMixingCurrentPosition not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAudioMixingPosition_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAudioMixingPosition_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAudioMixingDualMonoMode_38a5515(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAudioMixingDualMonoMode_38a5515 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAudioMixingPitch_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAudioMixingPitch_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAudioMixingPlaybackSpeed_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAudioMixingPlaybackSpeed_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getEffectsVolume() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getEffectsVolume not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setEffectsVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setEffectsVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    preloadEffect_282ba8c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_preloadEffect_282ba8c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    playEffect_531a783(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let soundId = obj.soundId;
        if (soundId === undefined) {
            AgoraConsole_1.AgoraConsole.error('soundId is undefined');
            throw 'soundId is undefined';
        }
        let filePath = obj.filePath;
        if (filePath === undefined) {
            AgoraConsole_1.AgoraConsole.error('filePath is undefined');
            throw 'filePath is undefined';
        }
        let loopCount = obj.loopCount;
        if (loopCount === undefined) {
            AgoraConsole_1.AgoraConsole.error('loopCount is undefined');
            throw 'loopCount is undefined';
        }
        let pitch = obj.pitch;
        if (pitch === undefined) {
            AgoraConsole_1.AgoraConsole.error('pitch is undefined');
            throw 'pitch is undefined';
        }
        let pan = obj.pan;
        if (pan === undefined) {
            AgoraConsole_1.AgoraConsole.error('pan is undefined');
            throw 'pan is undefined';
        }
        let gain = obj.gain;
        if (gain === undefined) {
            AgoraConsole_1.AgoraConsole.error('gain is undefined');
            throw 'gain is undefined';
        }
        let publish = obj.publish;
        if (publish === undefined) {
            AgoraConsole_1.AgoraConsole.error('publish is undefined');
            throw 'publish is undefined';
        }
        let startPos = obj.startPos;
        if (startPos === undefined) {
            AgoraConsole_1.AgoraConsole.error('startPos is undefined');
            throw 'startPos is undefined';
        }
        return this._impl.playEffect_531a783(soundId, filePath, loopCount, pitch, pan, gain, publish, startPos);
    }
    // @ts-ignore
    playAllEffects_20d7df2(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_playAllEffects_20d7df2 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getVolumeOfEffect_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getVolumeOfEffect_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setVolumeOfEffect_4e92b3c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setVolumeOfEffect_4e92b3c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    pauseEffect_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_pauseEffect_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    pauseAllEffects() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_pauseAllEffects not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    resumeEffect_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_resumeEffect_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    resumeAllEffects() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_resumeAllEffects not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopEffect_46f8ab7(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let soundId = obj.soundId;
        if (soundId === undefined) {
            AgoraConsole_1.AgoraConsole.error('soundId is undefined');
            throw 'soundId is undefined';
        }
        return this._impl.stopEffect_46f8ab7(soundId);
    }
    // @ts-ignore
    stopAllEffects() {
        return this._impl.stopAllEffects();
    }
    // @ts-ignore
    unloadEffect_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_unloadEffect_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    unloadAllEffects() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_unloadAllEffects not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getEffectDuration_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getEffectDuration_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setEffectPosition_4e92b3c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setEffectPosition_4e92b3c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getEffectCurrentPosition_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getEffectCurrentPosition_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableSoundPositionIndication_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableSoundPositionIndication_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRemoteVoicePosition_250b42d(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setRemoteVoicePosition_250b42d not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableSpatialAudio_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableSpatialAudio_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRemoteUserSpatialAudioParams_65a7855(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setRemoteUserSpatialAudioParams_65a7855 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setVoiceBeautifierPreset_4dd6319(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setVoiceBeautifierPreset_4dd6319 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAudioEffectPreset_92ea92c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAudioEffectPreset_92ea92c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setVoiceConversionPreset_d14ee73(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setVoiceConversionPreset_d14ee73 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAudioEffectParameters_73bc670(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAudioEffectParameters_73bc670 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setVoiceBeautifierParameters_f3cf745(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setVoiceBeautifierParameters_f3cf745 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setVoiceConversionParameters_2f5022e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setVoiceConversionParameters_2f5022e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLocalVoicePitch_bdb36bb(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLocalVoicePitch_bdb36bb not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLocalVoiceFormant_bdb36bb(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLocalVoiceFormant_bdb36bb not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLocalVoiceEqualization_d14012c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLocalVoiceEqualization_d14012c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLocalVoiceReverb_29c2013(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLocalVoiceReverb_29c2013 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setHeadphoneEQPreset_b679644(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setHeadphoneEQPreset_b679644 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setHeadphoneEQParameters_4e92b3c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setHeadphoneEQParameters_4e92b3c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableVoiceAITuner_28f5d5b(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableVoiceAITuner_28f5d5b not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLogFile_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLogFile_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLogFilter_2626ac7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLogFilter_2626ac7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLogLevel_f125d83(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let level = obj.level;
        if (level === undefined) {
            AgoraConsole_1.AgoraConsole.error('level is undefined');
            throw 'level is undefined';
        }
        return this._impl.setLogLevel_f125d83(level);
    }
    // @ts-ignore
    setLogFileSize_2626ac7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLogFileSize_2626ac7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    uploadLogFile_66d4ecd(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_uploadLogFile_66d4ecd not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    writeLog_62889f6(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_writeLog_62889f6 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLocalRenderMode_cfb201b(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let renderMode = obj.renderMode;
        if (renderMode === undefined) {
            AgoraConsole_1.AgoraConsole.error('renderMode is undefined');
            throw 'renderMode is undefined';
        }
        let mirrorMode = obj.mirrorMode;
        if (mirrorMode === undefined) {
            AgoraConsole_1.AgoraConsole.error('mirrorMode is undefined');
            throw 'mirrorMode is undefined';
        }
        return this._impl.setLocalRenderMode_cfb201b(renderMode, mirrorMode);
    }
    // @ts-ignore
    setRemoteRenderMode_6771ce0(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let uid = obj.uid;
        if (uid === undefined) {
            AgoraConsole_1.AgoraConsole.error('uid is undefined');
            throw 'uid is undefined';
        }
        let renderMode = obj.renderMode;
        if (renderMode === undefined) {
            AgoraConsole_1.AgoraConsole.error('renderMode is undefined');
            throw 'renderMode is undefined';
        }
        let mirrorMode = obj.mirrorMode;
        if (mirrorMode === undefined) {
            AgoraConsole_1.AgoraConsole.error('mirrorMode is undefined');
            throw 'mirrorMode is undefined';
        }
        return this._impl.setRemoteRenderMode_6771ce0(uid, renderMode, mirrorMode);
    }
    // @ts-ignore
    setLocalRenderTargetFps_2ad83d8(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLocalRenderTargetFps_2ad83d8 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRemoteRenderTargetFps_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setRemoteRenderTargetFps_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLocalRenderMode_bedb5ae(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let renderMode = obj.renderMode;
        if (renderMode === undefined) {
            AgoraConsole_1.AgoraConsole.error('renderMode is undefined');
            throw 'renderMode is undefined';
        }
        return this._impl.setLocalRenderMode_bedb5ae(renderMode);
    }
    // @ts-ignore
    setLocalVideoMirrorMode_b8a6c69(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let mirrorMode = obj.mirrorMode;
        if (mirrorMode === undefined) {
            AgoraConsole_1.AgoraConsole.error('mirrorMode is undefined');
            throw 'mirrorMode is undefined';
        }
        return this._impl.setLocalVideoMirrorMode_b8a6c69(mirrorMode);
    }
    // @ts-ignore
    enableDualStreamMode_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableDualStreamMode_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableDualStreamMode_9822d8a(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableDualStreamMode_9822d8a not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setDualStreamMode_3a7f662(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setDualStreamMode_3a7f662 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSimulcastConfig_3dcdfd7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setSimulcastConfig_3dcdfd7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setDualStreamMode_b3a4f6c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setDualStreamMode_b3a4f6c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableCustomAudioLocalPlayback_9566341(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableCustomAudioLocalPlayback_9566341 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRecordingAudioFrameParameters_bd46d1d(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setRecordingAudioFrameParameters_bd46d1d not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setPlaybackAudioFrameParameters_bd46d1d(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let sampleRate = obj.sampleRate;
        if (sampleRate === undefined) {
            AgoraConsole_1.AgoraConsole.error('sampleRate is undefined');
            throw 'sampleRate is undefined';
        }
        let channel = obj.channel;
        if (channel === undefined) {
            AgoraConsole_1.AgoraConsole.error('channel is undefined');
            throw 'channel is undefined';
        }
        let mode = obj.mode;
        if (mode === undefined) {
            AgoraConsole_1.AgoraConsole.error('mode is undefined');
            throw 'mode is undefined';
        }
        let samplesPerCall = obj.samplesPerCall;
        if (samplesPerCall === undefined) {
            AgoraConsole_1.AgoraConsole.error('samplesPerCall is undefined');
            throw 'samplesPerCall is undefined';
        }
        return this._impl.setPlaybackAudioFrameParameters_bd46d1d(sampleRate, channel, mode, samplesPerCall);
    }
    // @ts-ignore
    setMixedAudioFrameParameters_ee7e270(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setMixedAudioFrameParameters_ee7e270 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setEarMonitoringAudioFrameParameters_bd46d1d(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setEarMonitoringAudioFrameParameters_bd46d1d not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setPlaybackAudioFrameBeforeMixingParameters_4e92b3c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setPlaybackAudioFrameBeforeMixingParameters_4e92b3c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableAudioSpectrumMonitor_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableAudioSpectrumMonitor_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    disableAudioSpectrumMonitor() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_disableAudioSpectrumMonitor not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerAudioSpectrumObserver_0406ea7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_registerAudioSpectrumObserver_0406ea7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    unregisterAudioSpectrumObserver_0406ea7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_unregisterAudioSpectrumObserver_0406ea7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustRecordingSignalVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_adjustRecordingSignalVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    muteRecordingSignal_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_muteRecordingSignal_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustPlaybackSignalVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_adjustPlaybackSignalVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustUserPlaybackSignalVolume_88641bf(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_adjustUserPlaybackSignalVolume_88641bf not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLocalPublishFallbackOption_c29b788(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLocalPublishFallbackOption_c29b788 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRemoteSubscribeFallbackOption_c29b788(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setRemoteSubscribeFallbackOption_c29b788 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setHighPriorityUserList_ab88726(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setHighPriorityUserList_ab88726 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableExtension_d8b3874(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableExtension_d8b3874 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setExtensionProperty_f746b51(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setExtensionProperty_f746b51 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getExtensionProperty_18768d4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getExtensionProperty_18768d4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableLoopbackRecording_0b8eb79(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableLoopbackRecording_0b8eb79 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustLoopbackSignalVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_adjustLoopbackSignalVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getLoopbackRecordingVolume() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getLoopbackRecordingVolume not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableInEarMonitoring_077cf5f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableInEarMonitoring_077cf5f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setInEarMonitoringVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setInEarMonitoringVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    loadExtensionProvider_7a174df(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_loadExtensionProvider_7a174df not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setExtensionProviderProperty_0e4f59e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setExtensionProviderProperty_0e4f59e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerExtension_fd62af4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_registerExtension_fd62af4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableExtension_0b60a2c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableExtension_0b60a2c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setExtensionProperty_520ac55(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setExtensionProperty_520ac55 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getExtensionProperty_38c9723(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getExtensionProperty_38c9723 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCameraCapturerConfiguration_afa93b3(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCameraCapturerConfiguration_afa93b3 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    createCustomVideoTrack() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_createCustomVideoTrack not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    createCustomEncodedVideoTrack_0e9dc99(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_createCustomEncodedVideoTrack_0e9dc99 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    destroyCustomVideoTrack_3019423(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_destroyCustomVideoTrack_3019423 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    destroyCustomEncodedVideoTrack_3019423(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_destroyCustomEncodedVideoTrack_3019423 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    switchCamera() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_switchCamera not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isCameraZoomSupported() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isCameraZoomSupported not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isCameraFaceDetectSupported() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isCameraFaceDetectSupported not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isCameraTorchSupported() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isCameraTorchSupported not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isCameraFocusSupported() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isCameraFocusSupported not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isCameraAutoFocusFaceModeSupported() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isCameraAutoFocusFaceModeSupported not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCameraZoomFactor_685e803(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCameraZoomFactor_685e803 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableFaceDetection_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableFaceDetection_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getCameraMaxZoomFactor() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getCameraMaxZoomFactor not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCameraFocusPositionInPreview_f282d50(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCameraFocusPositionInPreview_f282d50 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCameraTorchOn_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCameraTorchOn_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCameraAutoFocusFaceModeEnabled_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCameraAutoFocusFaceModeEnabled_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isCameraExposurePositionSupported() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isCameraExposurePositionSupported not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCameraExposurePosition_f282d50(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCameraExposurePosition_f282d50 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isCameraExposureSupported() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isCameraExposureSupported not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCameraExposureFactor_685e803(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCameraExposureFactor_685e803 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isCameraAutoExposureFaceModeSupported() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isCameraAutoExposureFaceModeSupported not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCameraAutoExposureFaceModeEnabled_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCameraAutoExposureFaceModeEnabled_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCameraStabilizationMode_701b981(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCameraStabilizationMode_701b981 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setDefaultAudioRouteToSpeakerphone_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setDefaultAudioRouteToSpeakerphone_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setEnableSpeakerphone_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setEnableSpeakerphone_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isSpeakerphoneEnabled() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isSpeakerphoneEnabled not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRouteInCommunicationMode_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setRouteInCommunicationMode_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isCameraCenterStageSupported() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isCameraCenterStageSupported not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableCameraCenterStage_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableCameraCenterStage_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getScreenCaptureSources_f3e02cb(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getScreenCaptureSources_f3e02cb not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAudioSessionOperationRestriction_c492897(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAudioSessionOperationRestriction_c492897 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startScreenCaptureByDisplayId_ce89867(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startScreenCaptureByDisplayId_ce89867 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startScreenCaptureByScreenRect_e286286(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startScreenCaptureByScreenRect_e286286 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getAudioDeviceInfo_505aa0c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getAudioDeviceInfo_505aa0c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startScreenCaptureByWindowId_ce89867(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startScreenCaptureByWindowId_ce89867 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setScreenCaptureContentHint_8ad2c79(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setScreenCaptureContentHint_8ad2c79 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateScreenCaptureRegion_6b327a8(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_updateScreenCaptureRegion_6b327a8 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateScreenCaptureParameters_a2eef93(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_updateScreenCaptureParameters_a2eef93 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startScreenCapture_270da41(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let captureParams = obj.captureParams;
        if (captureParams === undefined) {
            AgoraConsole_1.AgoraConsole.error('captureParams is undefined');
            throw 'captureParams is undefined';
        }
        return this._impl.startScreenCapture_270da41(captureParams);
    }
    // @ts-ignore
    updateScreenCapture_270da41(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_updateScreenCapture_270da41 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    queryScreenCaptureCapability() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_queryScreenCaptureCapability not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    queryCameraFocalLengthCapability_2dee6af(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_queryCameraFocalLengthCapability_2dee6af not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setExternalMediaProjection_f337cbf(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setExternalMediaProjection_f337cbf not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setScreenCaptureScenario_13de7b4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setScreenCaptureScenario_13de7b4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopScreenCapture() {
        return this._impl.stopScreenCapture();
    }
    // @ts-ignore
    getCallId_66d4ecd(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getCallId_66d4ecd not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    rate_f1a0070(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_rate_f1a0070 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    complain_ccad422(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_complain_ccad422 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startRtmpStreamWithoutTranscoding_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startRtmpStreamWithoutTranscoding_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startRtmpStreamWithTranscoding_f76aa1a(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startRtmpStreamWithTranscoding_f76aa1a not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateRtmpTranscoding_91368d4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_updateRtmpTranscoding_91368d4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startLocalVideoTranscoder_90f9e33(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startLocalVideoTranscoder_90f9e33 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateLocalTranscoderConfiguration_90f9e33(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_updateLocalTranscoderConfiguration_90f9e33 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopRtmpStream_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopRtmpStream_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopLocalVideoTranscoder() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopLocalVideoTranscoder not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startLocalAudioMixer_a7ff78e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startLocalAudioMixer_a7ff78e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateLocalAudioMixerConfiguration_a7ff78e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_updateLocalAudioMixerConfiguration_a7ff78e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopLocalAudioMixer() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopLocalAudioMixer not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startCameraCapture_f3692cc(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startCameraCapture_f3692cc not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopCameraCapture_4fd718e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopCameraCapture_4fd718e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCameraDeviceOrientation_025aae8(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCameraDeviceOrientation_025aae8 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setScreenCaptureOrientation_025aae8(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setScreenCaptureOrientation_025aae8 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startScreenCapture_9ebb320(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startScreenCapture_9ebb320 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopScreenCapture_4fd718e(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let sourceType = obj.sourceType;
        if (sourceType === undefined) {
            AgoraConsole_1.AgoraConsole.error('sourceType is undefined');
            throw 'sourceType is undefined';
        }
        return this._impl.stopScreenCapture_4fd718e(sourceType);
    }
    // @ts-ignore
    getConnectionState() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getConnectionState not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerEventHandler_5fc0465(apiParam) {
        let eventHandler = apiParam.buffer[0]; //obj.eventHandler;
        if (eventHandler === undefined) {
            AgoraConsole_1.AgoraConsole.error('eventHandler is undefined');
            throw 'eventHandler is undefined';
        }
        return this._impl.registerEventHandler_5fc0465(eventHandler);
    }
    // @ts-ignore
    unregisterEventHandler_5fc0465(apiParam) {
        let eventHandler = apiParam.buffer[0]; //obj.eventHandler;
        if (eventHandler === undefined) {
            AgoraConsole_1.AgoraConsole.error('eventHandler is undefined');
            throw 'eventHandler is undefined';
        }
        return this._impl.unregisterEventHandler_5fc0465(eventHandler);
    }
    // @ts-ignore
    setRemoteUserPriority_f34115b(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setRemoteUserPriority_f34115b not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerPacketObserver_f8b44dd(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_registerPacketObserver_f8b44dd not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableEncryption_421c27b(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableEncryption_421c27b not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    createDataStream_b897a63(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_createDataStream_b897a63 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    createDataStream_5862815(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let config = obj.config;
        if (config === undefined) {
            AgoraConsole_1.AgoraConsole.error('config is undefined');
            throw 'config is undefined';
        }
        return this._impl.createDataStream_5862815(config);
    }
    // @ts-ignore
    sendStreamMessage_8715a45(apiParam) {
        let obj = JSON.parse(apiParam.data);
        obj = (0, CallApiBufferExtensions_1.callApiBufferExtension)(apiParam.event, obj, apiParam.buffer);
        let streamId = obj.streamId;
        if (streamId === undefined) {
            AgoraConsole_1.AgoraConsole.error('streamId is undefined');
            throw 'streamId is undefined';
        }
        let data = obj.data;
        if (data === undefined) {
            AgoraConsole_1.AgoraConsole.error('data is undefined');
            throw 'data is undefined';
        }
        let length = obj.length;
        if (length === undefined) {
            AgoraConsole_1.AgoraConsole.error('length is undefined');
            throw 'length is undefined';
        }
        return this._impl.sendStreamMessage_8715a45(streamId, data, length);
    }
    // @ts-ignore
    addVideoWatermark_eaef16d(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_addVideoWatermark_eaef16d not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    addVideoWatermark_7480410(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_addVideoWatermark_7480410 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    clearVideoWatermarks() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_clearVideoWatermarks not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    pauseAudio() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_pauseAudio not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    resumeAudio() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_resumeAudio not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableWebSdkInteroperability_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableWebSdkInteroperability_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    sendCustomReportMessage_56d6589(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let id = obj.id;
        if (id === undefined) {
            AgoraConsole_1.AgoraConsole.error('id is undefined');
            throw 'id is undefined';
        }
        let category = obj.category;
        if (category === undefined) {
            AgoraConsole_1.AgoraConsole.error('category is undefined');
            throw 'category is undefined';
        }
        let event = obj.event;
        if (event === undefined) {
            AgoraConsole_1.AgoraConsole.error('event is undefined');
            throw 'event is undefined';
        }
        let label = obj.label;
        if (label === undefined) {
            AgoraConsole_1.AgoraConsole.error('label is undefined');
            throw 'label is undefined';
        }
        let value = obj.value;
        if (value === undefined) {
            AgoraConsole_1.AgoraConsole.error('value is undefined');
            throw 'value is undefined';
        }
        return this._impl.sendCustomReportMessage_56d6589(id, category, event, label, value);
    }
    // @ts-ignore
    registerMediaMetadataObserver_8701fec(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_registerMediaMetadataObserver_8701fec not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    unregisterMediaMetadataObserver_8701fec(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_unregisterMediaMetadataObserver_8701fec not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startAudioFrameDump_aad7331(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startAudioFrameDump_aad7331 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopAudioFrameDump_a4c9af4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopAudioFrameDump_a4c9af4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAINSMode_4df3049(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAINSMode_4df3049 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerLocalUserAccount_ccad422(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let appId = obj.appId;
        if (appId === undefined) {
            AgoraConsole_1.AgoraConsole.error('appId is undefined');
            throw 'appId is undefined';
        }
        let userAccount = obj.userAccount;
        if (userAccount === undefined) {
            AgoraConsole_1.AgoraConsole.error('userAccount is undefined');
            throw 'userAccount is undefined';
        }
        return this._impl.registerLocalUserAccount_ccad422(appId, userAccount);
    }
    // @ts-ignore
    joinChannelWithUserAccount_0e4f59e(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let token = obj.token;
        if (token === undefined) {
            AgoraConsole_1.AgoraConsole.error('token is undefined');
            throw 'token is undefined';
        }
        let channelId = obj.channelId;
        if (channelId === undefined) {
            AgoraConsole_1.AgoraConsole.error('channelId is undefined');
            throw 'channelId is undefined';
        }
        let userAccount = obj.userAccount;
        if (userAccount === undefined) {
            AgoraConsole_1.AgoraConsole.error('userAccount is undefined');
            throw 'userAccount is undefined';
        }
        return this._impl.joinChannelWithUserAccount_0e4f59e(token, channelId, userAccount);
    }
    // @ts-ignore
    joinChannelWithUserAccount_4685af9(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let token = obj.token;
        if (token === undefined) {
            AgoraConsole_1.AgoraConsole.error('token is undefined');
            throw 'token is undefined';
        }
        let channelId = obj.channelId;
        if (channelId === undefined) {
            AgoraConsole_1.AgoraConsole.error('channelId is undefined');
            throw 'channelId is undefined';
        }
        let userAccount = obj.userAccount;
        if (userAccount === undefined) {
            AgoraConsole_1.AgoraConsole.error('userAccount is undefined');
            throw 'userAccount is undefined';
        }
        let options = obj.options;
        if (options === undefined) {
            AgoraConsole_1.AgoraConsole.error('options is undefined');
            throw 'options is undefined';
        }
        return this._impl.joinChannelWithUserAccount_4685af9(token, channelId, userAccount, options);
    }
    // @ts-ignore
    joinChannelWithUserAccountEx_268b977(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let token = obj.token;
        if (token === undefined) {
            AgoraConsole_1.AgoraConsole.error('token is undefined');
            throw 'token is undefined';
        }
        let channelId = obj.channelId;
        if (channelId === undefined) {
            AgoraConsole_1.AgoraConsole.error('channelId is undefined');
            throw 'channelId is undefined';
        }
        let userAccount = obj.userAccount;
        if (userAccount === undefined) {
            AgoraConsole_1.AgoraConsole.error('userAccount is undefined');
            throw 'userAccount is undefined';
        }
        let options = obj.options;
        if (options === undefined) {
            AgoraConsole_1.AgoraConsole.error('options is undefined');
            throw 'options is undefined';
        }
        return this._impl.joinChannelWithUserAccountEx_268b977(token, channelId, userAccount, options);
    }
    // @ts-ignore
    getUserInfoByUserAccount_c6a8f08(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let userAccount = obj.userAccount;
        if (userAccount === undefined) {
            AgoraConsole_1.AgoraConsole.error('userAccount is undefined');
            throw 'userAccount is undefined';
        }
        let userInfo = obj.userInfo;
        return this._impl.getUserInfoByUserAccount_c6a8f08(userAccount);
    }
    // @ts-ignore
    getUserInfoByUid_6b7aee8(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let uid = obj.uid;
        if (uid === undefined) {
            AgoraConsole_1.AgoraConsole.error('uid is undefined');
            throw 'uid is undefined';
        }
        let userInfo = obj.userInfo;
        return this._impl.getUserInfoByUid_6b7aee8(uid);
    }
    // @ts-ignore
    startOrUpdateChannelMediaRelay_e68f0a4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startOrUpdateChannelMediaRelay_e68f0a4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopChannelMediaRelay() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopChannelMediaRelay not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    pauseAllChannelMediaRelay() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_pauseAllChannelMediaRelay not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    resumeAllChannelMediaRelay() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_resumeAllChannelMediaRelay not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setDirectCdnStreamingAudioConfiguration_ac39c15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setDirectCdnStreamingAudioConfiguration_ac39c15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setDirectCdnStreamingVideoConfiguration_89677d8(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setDirectCdnStreamingVideoConfiguration_89677d8 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startDirectCdnStreaming_ed8d77b(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startDirectCdnStreaming_ed8d77b not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopDirectCdnStreaming() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopDirectCdnStreaming not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateDirectCdnStreamingMediaOptions_d2556c8(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_updateDirectCdnStreamingMediaOptions_d2556c8 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startRhythmPlayer_e1f6565(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startRhythmPlayer_e1f6565 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopRhythmPlayer() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_stopRhythmPlayer not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    configRhythmPlayer_b36c805(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_configRhythmPlayer_b36c805 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    takeSnapshot_1922dd1(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_takeSnapshot_1922dd1 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    takeSnapshot_5669ea6(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_takeSnapshot_5669ea6 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableContentInspect_e15e514(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableContentInspect_e15e514 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustCustomAudioPublishVolume_f8da2ca(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_adjustCustomAudioPublishVolume_f8da2ca not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustCustomAudioPlayoutVolume_f8da2ca(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_adjustCustomAudioPlayoutVolume_f8da2ca not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCloudProxy_39d115e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setCloudProxy_39d115e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLocalAccessPoint_798c8c7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setLocalAccessPoint_798c8c7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAdvancedAudioOptions_38d986b(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAdvancedAudioOptions_38d986b not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAVSyncSource_bf26e54(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_setAVSyncSource_bf26e54 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableVideoImageSource_5f39ea0(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableVideoImageSource_5f39ea0 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getCurrentMonotonicTimeInMs() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getCurrentMonotonicTimeInMs not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableWirelessAccelerate_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableWirelessAccelerate_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getNetworkType() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getNetworkType not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setParameters_3a2037f(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let parameters = obj.parameters;
        if (parameters === undefined) {
            AgoraConsole_1.AgoraConsole.error('parameters is undefined');
            throw 'parameters is undefined';
        }
        return this._impl.setParameters_3a2037f(parameters);
    }
    // @ts-ignore
    startMediaRenderingTracing() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_startMediaRenderingTracing not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableInstantMediaRendering() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_enableInstantMediaRendering not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getNtpWallTimeInMs() {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_getNtpWallTimeInMs not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isFeatureAvailableOnDevice_a694b62(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_isFeatureAvailableOnDevice_a694b62 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    sendAudioMetadata_878f309(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_sendAudioMetadata_878f309 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    queryHDRCapability_bebdacb(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngine_queryHDRCapability_bebdacb not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IRtcEngineDispatch = IRtcEngineDispatch;
